export const STATUS_LABELS = {
  draft: "Draft",
  submitted: "Submitted for Review",
  changes_requested: "Changes Requested",
  approved: "Approved",
  scheduled: "Scheduled",
  published: "Published",
};

export const STATUS_TONE = {
  draft: "bg-stone-100 text-stone-700 border-stone-200",
  submitted: "bg-blue-50 text-blue-700 border-blue-200",
  changes_requested: "bg-orange-50 text-orange-800 border-orange-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  scheduled: "bg-violet-50 text-violet-700 border-violet-200",
  published: "bg-green-100 text-green-800 border-green-300",
};

export function statusLabel(s) {
  return STATUS_LABELS[s] || s || "Draft";
}
export function statusTone(s) {
  return STATUS_TONE[s] || STATUS_TONE.draft;
}
